import logo from './logo.svg';
import './App.css';
import HomePage from './Pages/home';

function App() {
  return (
    <div className="App">
      <HomePage></HomePage>
    </div>
  );
}

export default App;
